(function () {
  window.theme = window.theme || {};

  if (window.theme.hpCollectionSnapshotsInit) {
    return;
  }

  window.theme.hpCollectionSnapshotsInit = true;

  var HP_COMPARE_POPUP_SELECTOR = '[data-hp-compare-popup]';
  var HP_COMPARE_POPUP_ID_PREFIX = 'hp-compare-popup-';

  function isHpComparePopup(popup) {
    return !!(popup && popup.hasAttribute && popup.hasAttribute('data-hp-compare-popup'));
  }

  function alignSectionHeights(sectionEl) {
    if (!sectionEl) return;

    var titles = sectionEl.querySelectorAll('.product-title');
    var titleMaxHeight = 0;

    titles.forEach(function (titleEl) { titleEl.style.height = ''; });

    titles.forEach(function (titleEl) {
      if (titleEl.clientHeight > titleMaxHeight) {
        titleMaxHeight = titleEl.clientHeight;
      }
    });

    titles.forEach(function (titleEl) {
      titleEl.style.height = titleMaxHeight ? titleMaxHeight + 'px' : '';
    });

    var priceRows = sectionEl.querySelectorAll('.product-item__price_and_reviews_row');
    priceRows.forEach(function (rowEl) { rowEl.style.height = ''; });

    if (window.innerWidth < 1680) {
      var subtitleMaxHeight = 0;

      priceRows.forEach(function (rowEl) {
        if (rowEl.clientHeight > subtitleMaxHeight) {
          subtitleMaxHeight = rowEl.clientHeight;
        }
      });

      priceRows.forEach(function (rowEl) {
        rowEl.style.height = subtitleMaxHeight ? subtitleMaxHeight + 'px' : '';
      });
    } else {
      priceRows.forEach(function (rowEl) {
        rowEl.style.height = '';
      });
    }
  }

  function loadSnapshotImage(image) {
    var picture = image.closest('picture');
    if (picture) picture.querySelectorAll('source[data-hp-snapshot-srcset]').forEach(function (source) {
      source.srcset = source.getAttribute('data-hp-snapshot-srcset');
      source.removeAttribute('data-hp-snapshot-srcset');
    });
    image.loading = 'eager';
    image.srcset = image.getAttribute('data-hp-snapshot-srcset');
    image.src = image.getAttribute('data-hp-snapshot-src');
    image.removeAttribute('data-hp-snapshot-image');
    image.removeAttribute('data-hp-snapshot-srcset');
    image.removeAttribute('data-hp-snapshot-src');
  }

  function observeSnapshotImages(sectionEl) {
    var images = sectionEl.querySelectorAll('img[data-hp-snapshot-image]');
    if (!images.length) return;
    var observer = window.IntersectionObserver && new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadSnapshotImage(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '400px 0px' });
    images.forEach(function (image) {
      if (observer) observer.observe(image);
      else loadSnapshotImage(image);
    });
    return function () { if (observer) observer.disconnect(); };
  }

  function observeSection(sectionEl) {
    if (sectionEl.ecoflowDisposeObservation) return;
    var disposeImages = observeSnapshotImages(sectionEl);
    var owner = sectionEl.closest('.shopify-section');
    function unloadImages(event) {
      if (event.target !== owner) return;
      if (disposeImages) disposeImages();
      document.removeEventListener('shopify:section:unload', unloadImages);
    }
    document.addEventListener('shopify:section:unload', unloadImages);
    window.ecoflowObserveSection(sectionEl, function () {
      alignSectionHeights(sectionEl);
      var width = sectionEl.clientWidth;
      var frame;
      var observer = window.ResizeObserver && new ResizeObserver(function () {
        if (width === sectionEl.clientWidth) return;
        width = sectionEl.clientWidth;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () { alignSectionHeights(sectionEl); });
      });
      if (observer) observer.observe(sectionEl);
      var active = true;
      if (document.fonts) document.fonts.ready.then(function () {
        if (active) alignSectionHeights(sectionEl);
      });
      return function () {
        active = false;
        cancelAnimationFrame(frame);
        if (observer) observer.disconnect();
      };
    });
  }

  function hydrateHover(event) {
    if (event.type === 'pointerover' && event.pointerType === 'touch') return;
    var card = event.target.closest('.hp-collection-snapshots__item');
    if (!card) return;
    card.querySelectorAll('img[data-home-hover-image]').forEach(function (image) {
      if (image.dataset.homeHoverLoading) return;
      image.dataset.homeHoverLoading = 'true';
      image.addEventListener('load', function () {
        image.removeAttribute('data-home-hover-image');
        delete image.dataset.homeHoverLoading;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
      }, { once: true });
      image.addEventListener('error', function () {
        delete image.dataset.homeHoverLoading;
      }, { once: true });
      image.loading = 'eager';
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
    });
  }

  function getOpenComparePopup() {
    return document.querySelector(HP_COMPARE_POPUP_SELECTOR + '.shown');
  }

  function bindCompareScroll(container) {
    container.onscroll = function () {
      var titleRow = container.querySelector('.comparison_feature_row.comparison_title_row');
      if (!titleRow) return;

      if (container.scrollTop > titleRow.clientHeight) {
        if (!titleRow.classList.contains('sticky')) {
          titleRow.classList.add('sticky');
          if (container.resizeComparison) container.resizeComparison();
        }
      } else {
        var wasSticky = titleRow.classList.contains('sticky');
        titleRow.classList.remove('sticky');
        if (wasSticky && container.resizeComparison) container.resizeComparison();
      }
    };
  }

  function openComparePopup(popupId, targetId) {
    if (!popupId || popupId.indexOf(HP_COMPARE_POPUP_ID_PREFIX) !== 0) return;

    var popup = document.getElementById(popupId);
    if (!isHpComparePopup(popup)) return;
    if (popup.disposeComparison) popup.disposeComparison();

    var sourceElem = targetId ? document.getElementById(targetId) : null;
    if (sourceElem) {
      var template = sourceElem.querySelector('template[data-hp-compare-content]');
      popup.querySelector('.popup-content').innerHTML = template ? template.innerHTML : sourceElem.innerHTML;
    }

    popup.classList.add('shown');
    document.body.classList.add('overflow-hidden');

    var container = popup.querySelector('.pdp-compare-table-container');
    if (container) {
      bindCompareScroll(container);
      initComparison(popup, container);
    }
  }

  function initComparison(popup, container) {
    var sliders = [];
    var resizeFrame;
    function resize() {
      var table = container.closest('.pdp-comparison-table');
      if (!table) return;
      table.style.setProperty('--product-info-height', 'auto');
      var height = 0;
      table.querySelectorAll('.compare_table_product_title').forEach(function (title) {
        height = Math.max(height, title.offsetHeight);
      });
      table.style.setProperty('--product-info-height', height + 'px');
      container.querySelectorAll('.comparison_feature_row').forEach(function (row) {
        row.style.setProperty('--row-height', 'auto');
        var title = row.querySelector('.compare_feature_title');
        var columns = row.querySelector('.compare_column_wrapper');
        if (title && columns) row.style.setProperty('--row-height', Math.max(title.clientHeight, columns.clientHeight) + 'px');
      });
      sliders.forEach(function (slider) { slider.resize(); });
    }
    function onResize() {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(resize);
    }
    container.resizeComparison = onResize;
    container.querySelectorAll('.view_features_link').forEach(function (button) {
      button.onclick = function () {
        button.parentElement.querySelector('.comparison_table').classList.toggle('show-all');
        var expanded = button.classList.toggle('showing-all');
        button.querySelector('span').textContent = button.getAttribute(expanded ? 'data-view-less-text' : 'data-view-more-text');
        resize();
      };
    });
    resize();
    window.addEventListener('resize', onResize);
    popup.disposeComparison = function () {
      window.removeEventListener('resize', onResize);
      cancelAnimationFrame(resizeFrame);
      sliders.forEach(function (slider) { slider.destroy(); });
    };
    if (!container.querySelector('.compare_column_slider')) return;
    container.setAttribute('aria-busy', 'true');
    window.ecoflowLoadHomeDependencies(['jquery', 'delegate', 'vendor']).then(function () {
      if (!container.isConnected) return;
      var title = container.querySelector('.compare_column_slider_title');
      container.querySelectorAll('.compare_column_slider').forEach(function (element) {
        sliders.push(new Flickity(element, {
          cellAlign: 'left', wrapAround: false, pageDots: false, contain: true,
          groupCells: true, prevNextButtons: true, selectedAttraction: 1,
          friction: 1, watchCSS: true,
          asNavFor: element === title ? undefined : title
        }));
      });
      resize();
    }).catch(function (error) {
      console.warn('[theme] comparison carousel unavailable', error);
    }).finally(function () { container.removeAttribute('aria-busy'); });
  }

  function closeComparePopup(popup) {
    if (!isHpComparePopup(popup)) return;

    popup.classList.remove('shown');
    if (popup.disposeComparison) popup.disposeComparison();
    popup.disposeComparison = null;

    var container = popup.querySelector('.pdp-compare-table-container');
    if (container) container.onscroll = null;

    var content = popup.querySelector('.popup-content');
    if (content) content.innerHTML = '';

    if (!getOpenComparePopup()) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  function handleCompareTrigger(trigger) {
    openComparePopup(trigger.getAttribute('data-popup'), trigger.getAttribute('data-target'));
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-compare-trigger]');
    if (trigger) {
      event.preventDefault();
      handleCompareTrigger(trigger);
      return;
    }

    var popup = event.target.closest(HP_COMPARE_POPUP_SELECTOR);
    if (popup && event.target === popup) {
      closeComparePopup(popup);
      return;
    }

    if (event.target.closest('.popup-close')) {
      var popupToClose = event.target.closest(HP_COMPARE_POPUP_SELECTOR);
      if (popupToClose) closeComparePopup(popupToClose);
    }
  });

  document.addEventListener('keydown', function (event) {
    var trigger = event.target.closest('[data-compare-trigger]');
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      handleCompareTrigger(trigger);
      return;
    }

    if (event.key === 'Escape') {
      var openPopup = getOpenComparePopup();
      if (openPopup) closeComparePopup(openPopup);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event.target.querySelector('.hp-collection-snapshots');
    if (sectionRoot) observeSection(sectionRoot);
  });

  function boot() {
    document.querySelectorAll('.hp-collection-snapshots').forEach(observeSection);
    document.addEventListener('pointerover', hydrateHover, { passive: true });
    document.addEventListener('focusin', hydrateHover);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
